export default __webpack_public_path__ + "2deef672f6481ba73a51186723686e35.png";